const ToggleButtons = require('../header-dropdown/toggle-buttons')

module.exports = () => {
  const header = document.querySelector('.hse-header')
  if (header) {
    ToggleButtons('.hse-header__')
  }
}
